<template>
  <div class="wrongThesaurus">
    <div class="wrongThesaurus-left">
      <el-alert
        class="title"
        title="添加"
        type="success"
        :closable="false"
      />
      <el-form ref="form" :model="form" label-width="auto">
        <el-form-item label="错词">
          <el-input v-model="form.wrong_word" size="mini" @input="changeName" />
        </el-form-item>
        <el-form-item label="正词">
          <el-input v-model="form.right_word" size="mini" />
        </el-form-item>
        <el-form-item label="语境">
          <el-input type="textarea" v-model="form.context"  size="mini" />
        </el-form-item>
      </el-form>
      <div class="btns">
        <base-upload  @txtContent="getTxtContent" />
        <el-button type="primary" size="small" @click="add">添加</el-button>
      </div>
    </div>
     <div class="thesaurus-right">
      <el-alert
        class="title"
        title="查询"
        type="success"
        :closable="false"
      />
      <el-row :gutter="20">
        <el-col :span="18">
          <el-input v-model="query"  size="mini" />
        </el-col>
        <el-col :span="6">
          <el-button size="mini" @click="handleQuery">查询</el-button>
        </el-col>
      </el-row>
      <base-table
        :tableTitle="tableTitle"
        :tableData="tableData"
      >
      <template v-slot:operation="{ rowDate }">
        <el-button type="primary" size="mini" @click="showDialog(rowDate)">修改</el-button>
        <el-button type="danger" size="mini" @click="removeRow(rowDate)">删除</el-button>
      </template>
      </base-table>
      <base-pagination
        :total.sync="tableData.length"
        :page.sync="params.page"
        :limit.sync="params.size"
        @pagination="changePage"
      />
    </div>
    <!-- 弹窗 -->
    <base-dialog
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :formRules="dialog.formRules"
      :formData.sync="dialog.params"
      @submit="updateSubmit"
    />

  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable/index';
import BasePagination from '@/components/BasePagination/index';
import BaseDialog from '@/components/BaseDialog/index';
import BaseUpload from '@/components/BaseUpload/index';
import {
  getWrongThesaurus,
  deleteWrongThesaurus,
  addWrongThesaurus,
  modifyWrongThesaurus,
} from '@/api/index';

export default {
  name: 'wrongThesaurus',
  data() {
    return {
      form: {
        wrong_word: '',
        right_word: '',
        context: '',
      },
      query: '',
      tableTitle: [
      {
        label: '错词',
        prop: 'wrong_word',
      },
      {
        label: '正词',
        prop: 'right_word',
      },
      {
        label: '语境',
        prop: 'context',
      },
      {
        label: '增加日期',
        prop: 'add_time',
      },
      {
        label: '操作',
        prop: 'operation',
        width: 150
      }],
      tableData: [],
      params: {
        total: 0,
        page: 1,
        size: 10,
      },
      userJson: {},
      dialog: {
        title: '修改错词库',
        visible: false,
        formRules: [{
          name: '错词库',
          prop: 'new_wrong_word',
          inputType: 'text',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        },
        {
          name: '正词库',
          prop: 'new_right_word',
          inputType: 'text',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        },
        {
          name: '语境',
          prop: 'new_context',
          inputType: 'textarea',
          rules: [{ required: true, message: '不能为空', trigger: 'blur' }],
        }],
        params: {
          context: '',
          right_word: '',
          wrong_word: '',
          new_right_word: '',
          new_context: '',
          new_wrong_word: ''
        },
      }
    };
  },
  components: {
    BaseTable,
    BasePagination,
    BaseDialog,
    BaseUpload,
  },
  created() {
    this.$nextTick(() => {
      const { wps } = localStorage;
      this.userJson = JSON.parse(wps);
      this.getList();
    })
  },
  methods: {
    changeName(val) {
      this.form.context = val;
    },
    handleQuery() {
      this.params = {
        total: 0,
        page: 1,
        size: 10,
      }
      this.tableData = [];
      this.getList();
    },
    async getList() {
      const res = await getWrongThesaurus({
        word: this.query,
        page_no: this.params.page,
        token: this.userJson.token,
      });
      this.tableData = res || [];
      console.log(this.tableData);
    },
    async add() {
      const res = await addWrongThesaurus({
        ...this.form,
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      } else {
        this.$message({
          message: res.return_msg,
          type: 'error'
        });
      }
      this.params.page = 1;
      this.getList();
    },
    async removeRow(row) {
      const { right_word, wrong_word, context } = row
      const res = await deleteWrongThesaurus({
        right_word,
        context,
        wrong_word,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
      }
      this.getList();
    },
    changePage() {
      this.getList();
    },
    async updateSubmit(val) {
      const {
        right_word,
        wrong_word,
        context,
        new_wrong_word,
        new_right_word,
        new_context,
      } = val;
      const res = await modifyWrongThesaurus({
        right_word,
        wrong_word,
        context,
        new_context,
        new_right_word,
        new_wrong_word,
        token: this.userJson.token,
      });
      if(res.return_code == 0) {
        this.$message({
          message: res.return_msg,
          type: 'success'
        });
        this.dialog.visible = false;
      }
      this.getList();
    },
    showDialog(row) {
      const { context, right_word, wrong_word } = row
      this.dialog = {
        ...this.dialog,
        visible: true,
        params: {
          ...row,
          new_wrong_word: wrong_word,
          new_right_word: right_word,
          new_context: context,
        }
      }
    },
    getTxtContent(list) {
      list.forEach((item) => {
        this.import_(item);
      });
    },
    async import_(item) {
      if(item.length < 3) {
        this.$message({
          message: '文件格式错误！',
          type: 'error'
        })
        return;
      }
      const res = await addWrongThesaurus({
        wrong_word: item[0],
        right_word: item[1],
        context: item[2],
        user_code: this.userJson.user.userid,
        token: this.userJson.token,
      });

      if(res.return_code == 1) {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
      this.params.page = 1;
      this.getList();
    },
  }
};
</script>

<style scoped>
.wrongThesaurus {
  height: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  color: black;
}

.wrongThesaurus-left  {
  flex: 1;
}

.wrongThesaurus-right {
  /* padding-left: 30px; */
  width: 55%;
}

.wrongThesaurus-left  {
  margin-right: 50px;
}

.title {
  margin-bottom: 12px;
}
::v-deep .el-textarea__inner {
  min-height: 200px!important;
}

.btns {
  display: flex;
  justify-content: flex-end;
}
</style>